import { useMemo, useState } from 'react';
import { NewTable, NewTableColumn } from 'shared/components/NewTable';
import { ViajeTrasladoLog } from '../models/ViajeTrasladoLog';
import ExpandableTextCell from 'shared/components/Table/ExpandableTextCell';

interface Props {
  data: ViajeTrasladoLog[];
}

const ROWS_PER_PAGE_OPTIONS = [5, 10, 25];

export const ViajeTrasladoModificacionesTable = ({ data }: Props) => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const columns = useMemo<NewTableColumn<ViajeTrasladoLog>[]>(
    () => [
      {
        key: 'fecha',
        label: 'Fecha',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">
            {row.fecha_hora.format('DD/MM/YYYY HH:mm')}
          </span>
        )
      },
      {
        key: 'user_name',
        label: 'Usuario',
        width: '20%',
        render: (row) => (
          <span className="text-ink dark:text-ink-dark">
            {row.user?.name ?? ''}
          </span>
        )
      },
      {
        key: 'observacion',
        label: 'Observación',
        width: '50%',
        render: (row) => (
          <ExpandableTextCell
            text={row.observacion}
            maxWidthClass="w-44"
            isMobileOrTablet={false}
          />
        )
      }
    ],
    []
  );

  const paginatedData = useMemo(() => {
    const start = (page - 1) * rowsPerPage;
    return data.slice(start, start + rowsPerPage);
  }, [data, page, rowsPerPage]);

  return (
    <NewTable
      columns={columns}
      data={paginatedData}
      getRowKey={(row) => row.id}
      page={page}
      rowsPerPage={rowsPerPage}
      total={data.length}
      onChangePage={setPage}
      onChangeRowsPerPage={(value) => {
        setRowsPerPage(value);
        setPage(1);
      }}
      rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
      emptyTitle="No hay modificaciones registradas"
    />
  );
};
